
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

export default function SuaBangChotCongThang() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const defaultdetail = {
        author_id: user.data.id, title: '', company_id: '', time_start: '', type: "Chấm vào", level: 1, comment: ''
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "baocaochamcong/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'baocaochamcong/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật cài đặt thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } 
        },
    });

    return (
        <AkkhorLayout idrole="list-users_onday">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/bangchotcongthang">Bảng chốt công</Link>
                    </li>
                    <li>Cập nhật chốt công công {detail && "tháng " + detail.month + '/' + detail.year}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Cập nhật chốt công công {detail && "tháng " + detail.month + '/' + detail.year}</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-12 col-sm-6 form-group">
                                <label>Mã nhân viên</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("code")} readOnly />
                            </div>

                            <div className="col-12 col-sm-6 form-group">
                                <label>Kỳ công tháng</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("month")} readOnly />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Từ ngày</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("datestart")} readOnly />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tới ngày</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("dateend")} readOnly />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Công chuẩn</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("congchuan")} readOnly />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Công HL</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("conghl")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Công thực tế</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("congtt")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Công NVP</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("congnvp")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Công tác</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("congct")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ phép</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("nghiphep")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ bù</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("nghibu")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ lễ</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("nghile")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ chế độ</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("nghichedo")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ ốm</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("nghiom")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ KL</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("nghikl")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>M/S dưới 10'</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("sldmvs1")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>M/S từ 10' - 30'</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("sldmvs2")} />
                            </div>
                           
                            <div className="col-6 col-sm-2 form-group">
                                <label>M/S trên 30'</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("sldmvs3")} />
                            </div>
                           
                            <div className="col-6 col-sm-2 form-group">
                                <label>KV-KR</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("slkcc")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Không giải trình</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("slkgt")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Nghỉ không phép</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("slnkp")} />
                            </div>
                            <div className="col-6 col-sm-2 form-group">
                                <label>Không duyệt</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("slkpd")} />
                            </div>
                           

                            <div className="col-12 form-group mt-3">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
